import { ReactComponent as InfoIcon } from "../../shared/assets/informationLogo.svg";
import { themeAtom } from "../../shared/atoms";
import { VesselRatings } from "../../voyage-assessment/models/voyage-assesment.models";
import { useAtomValue } from "jotai";
import { Tooltip } from "react-tooltip";
import { twMerge } from "tailwind-merge";

type Props = { vesselRatings: VesselRatings | undefined };

export function SafetyScore({ vesselRatings }: Props) {
  const theme = useAtomValue(themeAtom);

  const infoText =
    'Based on the RightShip DOC score and adjusted by Cargill\'s internal safety score as a confidence indicator: "+" ' +
    'if Cargill\'s score is higher, "-" if lower, or no change if the scores are equal.';

  return (
    <div className="mb-6 flex-[33%] flex-grow-0">
      <div data-test="quality-rating">
        <p className={twMerge("] mb-1 flex flex-row items-baseline gap-2 text-[14px]", theme.vesselDetails.infoText)}>
          Safety Score
          <InfoIcon className="mt-1 flex h-3.5 w-3.5" data-tooltip-id="safety-score" data-tooltip-html={infoText} />
          <Tooltip
            id="safety-score"
            disableStyleInjection={true}
            style={{
              color: theme.headerComponent.inline.tooltipText,
              background: theme.headerComponent.inline.tooltipBackground,
              borderRadius: "8px",
              position: "absolute",
              top: "0",
              width: "400px",
            }}
          />
        </p>
        <div className="flex items-center">
          <strong className={twMerge("] text-[18px]", theme.home.tailwind.textDefault)}>
            {safetyScore(vesselRatings)}
          </strong>
          <span className={twMerge("text-[12px] font-bold", theme.vesselDetails.fields)}>/5</span>
        </div>
      </div>
    </div>
  );
}

function safetyScore(vr: VesselRatings | undefined): string | undefined {
  const safetyScoreCg = vr?.safetyScoreCg ?? 0;
  const safetyScoreRs = vr?.safetyScoreRs ?? 0;

  if (safetyScoreCg === 0 && safetyScoreRs === 0) {
    return "-";
  } else if (safetyScoreCg > safetyScoreRs) {
    return `${safetyScoreRs}+`;
  } else if (safetyScoreCg === safetyScoreRs) {
    return String(safetyScoreRs);
  } else if (safetyScoreCg < safetyScoreRs) {
    return `${safetyScoreRs}-`;
  }
}
